import { render, staticRenderFns } from "./DefaultSurvey.vue?vue&type=template&id=4ed12a74&"
import script from "./DefaultSurvey.vue?vue&type=script&lang=js&"
export * from "./DefaultSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'directives', {ClosePopup});
